var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#EB3000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2246 25V9.16H14.2166V16.464L20.2446 9.16H23.8966L17.2746 16.97L24.3146 25H20.5306L14.2166 17.784V25H11.2246Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 34.0033C14.534 29.7134 8.25 31.392 8.25 35.6074C8.25 40.3449 14.7727 42.0236 16.9601 46.4254L16.9999 46.5L17.0397 46.4254C19.2272 42.0236 25.7498 40.3449 25.7498 35.6074C25.7896 31.392 19.4658 29.7134 16.9999 34.0033Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9998 50.0059C32.5612 42.2841 21.25 45.3057 21.25 52.8932C21.25 61.4208 32.9908 64.4424 36.9282 72.3657L36.9998 72.5L37.0714 72.3657C41.0089 64.4424 52.7497 61.4208 52.7497 52.8932C52.8213 45.3057 41.4384 42.2841 36.9998 50.0059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKh);
export default __webpack_public_path__ + "static/media/kh.933ab1aa8d64485580d68c3127971709.svg";
export { ForwardRef as ReactComponent };